import ExpandableSection from "../component/_expandableSection";
document.addEventListener('DOMContentLoaded', function() {
    const navItems = document.querySelectorAll('.js-header-nav-item');
    const megaMenus = document.querySelectorAll('.js-header-mega-menu-wrapper');
    const megaMenusContent = document.querySelectorAll('.js-header-mega-menu-content');
    const sidebarItems = document.querySelectorAll('.js-header-mega-menu-item');
    const hamburgerBtn = document.querySelector('.js-header-hamburger-icon');
    const hamburgerMenu = document.querySelector('.js-header-mobile-menu');
    const childLinks = document.querySelectorAll('.js-header-mobile-child-link');
    const grandchildBackButtons = document.querySelectorAll('.js-header-mobile-grandchild-back');
    const headerMegaMenu = document.querySelector('.js-header-mega-menu');

    let lastScrollTop = 0;
    const header = document.querySelector('.js-header');

    updateMaxHeight();
    // Aktualizacja przy zmianie rozmiaru okna
    window.addEventListener('resize', updateMaxHeight);

    function updateMaxHeight() {
        // Pobranie wysokości okna przeglądarki
        const windowHeight = window.innerHeight;
        // Znalezienie elementu nagłówka
        const header = document.querySelector('.js-header');
        // Jeśli nagłówek istnieje, pobieramy jego wysokość, w przeciwnym razie przyjmujemy 0
        const headerHeight = header ? header.offsetHeight : 0;
        // Znalezienie elementu, dla którego ustawiamy max-height
        const megaMenu = document.querySelector('.js-header-mobile-grandchild-panel');
        if (megaMenu) {
            // Ustawienie maksymalnej wysokości jako różnicy wysokości okna i nagłówka
            megaMenu.style.maxHeight = (windowHeight - headerHeight) + 'px';
        }
    }

// Funkcja do wyrównania pozycji mega menu dla header__nav-item--list
    function alignListMenuPosition() {
        const listNavItems = document.querySelectorAll('.js-header-nav-item.header__nav-item--list');

        listNavItems.forEach(navItem => {
            const targetSlug = navItem.dataset.target;
            const megaMenuWrapper = document.querySelector(`.js-header-mega-menu-wrapper[data-parent="${targetSlug}"]`);

            if (megaMenuWrapper) {
                // Pobierz kontener (rodzica elementu nawigacji)
                const container = document.querySelector('.header__container');
                // Obliczanie pozycji lewej krawędzi elementu nawigacji względem kontenera
                const navItemRect = navItem.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();

                // Różnica między lewą krawędzią elementu nawigacji a lewą krawędzią kontenera
                const offsetFromContainer = navItemRect.left - containerRect.left - 30;

                // Ustawiamy pozycję left dla mega menu taką samą jak offset elementu nawigacji od kontenera
                megaMenuWrapper.style.left = `${offsetFromContainer}px`;
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        // Istniejący kod...

        // Wywołanie funkcji przy załadowaniu oraz przy zmianie rozmiaru okna
        alignListMenuPosition();
        window.addEventListener('resize', alignListMenuPosition);

        // Reszta istniejącego kodu...
    });

    alignListMenuPosition();
    window.addEventListener('resize', alignListMenuPosition);


    window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowWidth = window.innerWidth;
        if (windowWidth >= 992) {
            if (scrollTop > lastScrollTop) {
                header.classList.add('hidden');
            } else {
                header.classList.remove('hidden');
            }
        } else {
            // Dla szerokości <= 992 - upewnij się, że nagłówek jest widoczny
            header.classList.remove('hidden');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Zapobiega wartościom ujemnym
    });

    childLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetSlug = this.getAttribute('data-target');
            const grandchildPanel = document.querySelector(`.js-header-mobile-grandchild-panel[data-parent="${targetSlug}"]`);
            if (grandchildPanel) {
                grandchildPanel.classList.add('header__mobile-grandchild-panel--active');
            }
        });
    });

    grandchildBackButtons.forEach(button => {
        button.addEventListener('click', function() {
            const parentSlug = this.getAttribute('data-parent');
            const grandchildPanel = document.querySelector(`.js-header-mobile-grandchild-panel[data-parent="${parentSlug}"]`);
            grandchildPanel.classList.remove('header__mobile-grandchild-panel--active');
        });
    });

    hamburgerBtn.addEventListener('click', function() {
        this.classList.toggle('header__hamburger-icon--active');
        hamburgerMenu.classList.toggle('header__mobile-menu--active');
        document.body.style.overflow = document.body.style.overflow === 'hidden' ? 'auto' : 'hidden';
    });

    new ExpandableSection('.js-mobile-nav-item', '.js-header-mobile-nav-title', '.js-header-mobile-submenu', '.js-header-mobile-nav-chevron', true, true);

    let maxHeight = 0;

    // Obliczenie maksymalnej wysokości dla wszystkich mega menu
    megaMenusContent.forEach(menu => {
        menu.style.display = 'block';
        const height = menu.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
        menu.style = '';
    });

    // Ustawienie maksymalnej wysokości dla wszystkich mega menu
    megaMenus.forEach(menu => {
        if(menu.classList.contains('header__mega-menu-wrapper--hidden-content')) {
            return;
        }
        menu.style.height = `${maxHeight}px`;
    });

    // Pokazywanie mega menu po najechaniu na główny element
    navItems.forEach(item => {
        const target = item.dataset.target;
        item.addEventListener('mouseenter', () => {
            navItems.forEach(navItem => navItem.classList.remove('header__nav-item--active'));
            item.classList.add('header__nav-item--active');
            megaMenus.forEach(menu => {
                if (menu.dataset.parent === target) {
                    menu.classList.add('header__mega-menu-wrapper--active');
                    headerMegaMenu.classList.add('header__mega-menu--active');
                    const firstSidebarItem = menu.querySelector('.js-header-mega-menu-item');
                    if (firstSidebarItem) {
                        firstSidebarItem.click();
                    }
                } else {
                    menu.classList.remove('header__mega-menu-wrapper--active');
                }
            });
        });
    });

    // Ukrywanie mega menu, gdy myszka opuszcza obszar nawigacji
    document.querySelector('.header').addEventListener('mouseleave', () => {
        megaMenus.forEach(menu => menu.classList.remove('header__mega-menu-wrapper--active'));
        headerMegaMenu.classList.remove('header__mega-menu--active');
        navItems.forEach(item => item.classList.remove('header__nav-item--active'));
    });

    // Otwieranie odpowiedniej zawartości w sidebarze po kliknięciu
    sidebarItems.forEach(item => {
        const parent = item.closest('.header__mega-menu-wrapper');
        item.addEventListener('click', (e) => {
            e.preventDefault();

            const relatedContent = parent.querySelector(`.js-header-mega-menu-content[data-related="${item.dataset.target}"]`);
            const allContentItems = parent.querySelectorAll('.js-header-mega-menu-content');

            // Zaznaczanie aktywnego elementu w sidebarze
            parent.querySelectorAll('.js-header-mega-menu-item').forEach(el => el.classList.remove('header__mega-menu-item--active'));
            item.classList.add('header__mega-menu-item--active');

            // Pokazywanie odpowiedniego kontentu dla wybranego elementu
            allContentItems.forEach(contentItem => contentItem.style.display = 'none');
            if (relatedContent) {
                relatedContent.style.display = 'block';
            }
        });
    });
});


